/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface EmployeeShiftsService {
  /**
   * @summary Get Shifts
   * @description Get employee shifts with optional filters.
   */
  getShiftsEmployeesShiftsGet: {
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetShiftsEmployeesShiftsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetShiftsEmployeesShiftsGetSchema,
        options: {
          parameters: GetShiftsEmployeesShiftsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetError>>
    ): Promise<RequestFnResponse<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetError>>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    getQueryKey(
      parameters: DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | void
    ): ServiceOperationQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useQuery({
     *     query: {
     *         date_gte: dateGte
     *     }
     * })
     * ```
     */
    useQuery<TData = GetShiftsEmployeesShiftsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        | (DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetShiftsEmployeesShiftsGetData,
          GetShiftsEmployeesShiftsGetError,
          TData,
          ServiceOperationQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetShiftsEmployeesShiftsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useQuery({
     *     query: {
     *         date_gte: dateGte
     *     }
     * })
     * ```
     */
    useQuery<TData = GetShiftsEmployeesShiftsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        | (DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetShiftsEmployeesShiftsGetData,
          GetShiftsEmployeesShiftsGetError,
          TData,
          ServiceOperationQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetShiftsEmployeesShiftsGetError>>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             date_gte: initialDateGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetShiftsEmployeesShiftsGetParameters,
      TQueryFnData = GetShiftsEmployeesShiftsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetShiftsEmployeesShiftsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        | (DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetShiftsEmployeesShiftsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetShiftsEmployeesShiftsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             date_gte: initialDateGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetShiftsEmployeesShiftsGetParameters,
      TQueryFnData = GetShiftsEmployeesShiftsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetShiftsEmployeesShiftsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        | (DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetShiftsEmployeesShiftsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetShiftsEmployeesShiftsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetShiftsEmployeesShiftsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getShiftsEmployeesShiftsGetTotal = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getShiftsEmployeesShiftsGetByParametersTotal = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             date_gte: dateGte
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
        | QueryFiltersByQueryKey<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getShiftsEmployeesShiftsGetResults = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 date_gte: dateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 date_gte: dateGte2
     *             }
     *         }
     *     ]
     * });
     * getShiftsEmployeesShiftsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getShiftsEmployeesShiftsGetCombinedResults = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 date_gte: dateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 date_gte: dateGte2
     *             }
     *         }
     *     ]
     * });
     * getShiftsEmployeesShiftsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetShiftsEmployeesShiftsGetSchema,
          GetShiftsEmployeesShiftsGetParameters,
          GetShiftsEmployeesShiftsGetData,
          GetShiftsEmployeesShiftsGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useSuspenseQuery({
     *     query: {
     *         date_gte: dateGte
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetShiftsEmployeesShiftsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        | (DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetShiftsEmployeesShiftsGetData,
          GetShiftsEmployeesShiftsGetError,
          TData,
          ServiceOperationQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetShiftsEmployeesShiftsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             date_gte: initialDateGte
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetShiftsEmployeesShiftsGetParameters,
      TData = GetShiftsEmployeesShiftsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        | (DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetShiftsEmployeesShiftsGetData,
          GetShiftsEmployeesShiftsGetError,
          OperationInfiniteData<TData, GetShiftsEmployeesShiftsGetParameters>,
          ServiceOperationInfiniteQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetShiftsEmployeesShiftsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetShiftsEmployeesShiftsGetParameters>,
      OperationError<GetShiftsEmployeesShiftsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getShiftsEmployeesShiftsGetData = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 date_gte: dateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 date_gte: dateGte2
     *             }
     *         }
     *     ]
     * });
     * getShiftsEmployeesShiftsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getShiftsEmployeesShiftsGetCombinedData = qraft.employeeShiftsService.getShiftsEmployeesShiftsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 date_gte: dateGte1
     *             }
     *         },
     *         {
     *             query: {
     *                 date_gte: dateGte2
     *             }
     *         }
     *     ]
     * });
     * getShiftsEmployeesShiftsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetShiftsEmployeesShiftsGetSchema,
          GetShiftsEmployeesShiftsGetParameters,
          GetShiftsEmployeesShiftsGetData,
          GetShiftsEmployeesShiftsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetShiftsEmployeesShiftsGetSchema,
        GetShiftsEmployeesShiftsGetData,
        GetShiftsEmployeesShiftsGetParameters,
        GetShiftsEmployeesShiftsGetError
      > | void
    ): Promise<GetShiftsEmployeesShiftsGetData>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetShiftsEmployeesShiftsGetSchema,
        GetShiftsEmployeesShiftsGetData,
        GetShiftsEmployeesShiftsGetParameters,
        GetShiftsEmployeesShiftsGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetShiftsEmployeesShiftsGetSchema,
        GetShiftsEmployeesShiftsGetData,
        GetShiftsEmployeesShiftsGetParameters,
        GetShiftsEmployeesShiftsGetError
      > | void
    ): Promise<GetShiftsEmployeesShiftsGetData>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    fetchInfiniteQuery<TPageParam extends GetShiftsEmployeesShiftsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetShiftsEmployeesShiftsGetSchema,
        GetShiftsEmployeesShiftsGetData,
        GetShiftsEmployeesShiftsGetParameters,
        DeepReadonly<TPageParam>,
        GetShiftsEmployeesShiftsGetError
      > | void
    ): Promise<OperationInfiniteData<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetParameters>>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    prefetchInfiniteQuery<TPageParam extends GetShiftsEmployeesShiftsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetShiftsEmployeesShiftsGetSchema,
        GetShiftsEmployeesShiftsGetData,
        GetShiftsEmployeesShiftsGetParameters,
        DeepReadonly<TPageParam>,
        GetShiftsEmployeesShiftsGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    ensureInfiniteQueryData<TPageParam extends GetShiftsEmployeesShiftsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetShiftsEmployeesShiftsGetSchema,
        GetShiftsEmployeesShiftsGetData,
        GetShiftsEmployeesShiftsGetParameters,
        DeepReadonly<TPageParam>,
        GetShiftsEmployeesShiftsGetError
      > | void
    ): Promise<OperationInfiniteData<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetParameters>>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        | (DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | void)
    ): GetShiftsEmployeesShiftsGetData | undefined;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        | (DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | void)
    ): OperationInfiniteData<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetParameters> | undefined;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
        | QueryFiltersByQueryKey<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetShiftsEmployeesShiftsGetSchema,
              GetShiftsEmployeesShiftsGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetShiftsEmployeesShiftsGetSchema,
              GetShiftsEmployeesShiftsGetParameters
            >,
            data: GetShiftsEmployeesShiftsGetData | undefined,
          ]
        >;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        | (DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | void)
    ): QueryState<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetError> | undefined;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetShiftsEmployeesShiftsGetParameters>
        | ServiceOperationInfiniteQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetParameters>,
          GetShiftsEmployeesShiftsGetError
        >
      | undefined;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | undefined)
        | ServiceOperationQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>,
      updater: Updater<
        NoInfer<GetShiftsEmployeesShiftsGetData> | undefined,
        NoInfer<DeepReadonly<GetShiftsEmployeesShiftsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetShiftsEmployeesShiftsGetData | undefined;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetShiftsEmployeesShiftsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetShiftsEmployeesShiftsGetSchema, GetShiftsEmployeesShiftsGetParameters>,
      updater: Updater<
        | NoInfer<OperationInfiniteData<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<OperationInfiniteData<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetParameters>>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetShiftsEmployeesShiftsGetData, GetShiftsEmployeesShiftsGetParameters> | undefined;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
        | QueryFiltersByQueryKey<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >,
      updater: Updater<
        NoInfer<GetShiftsEmployeesShiftsGetData> | undefined,
        NoInfer<GetShiftsEmployeesShiftsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetShiftsEmployeesShiftsGetData | undefined>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetShiftsEmployeesShiftsGetSchema,
        GetShiftsEmployeesShiftsGetData,
        TInfinite,
        GetShiftsEmployeesShiftsGetParameters,
        GetShiftsEmployeesShiftsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
        | QueryFiltersByQueryKey<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
        | QueryFiltersByQueryKey<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
        | QueryFiltersByQueryKey<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
    ): void;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
        | QueryFiltersByQueryKey<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Shifts
     * @description Get employee shifts with optional filters.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
        | QueryFiltersByQueryKey<
            GetShiftsEmployeesShiftsGetSchema,
            GetShiftsEmployeesShiftsGetData,
            TInfinite,
            GetShiftsEmployeesShiftsGetParameters,
            GetShiftsEmployeesShiftsGetError
          >
    ): number;
    schema: GetShiftsEmployeesShiftsGetSchema;
    types: {
      parameters: GetShiftsEmployeesShiftsGetParameters;
      data: GetShiftsEmployeesShiftsGetData;
      error: GetShiftsEmployeesShiftsGetError;
    };
  };
  /**
   * @summary Batch Upsert Shifts
   * @description Bulk upsert employee shifts by employee_id and date.
   */
  batchUpsertShifts: {
    /**
     * @summary Batch Upsert Shifts
     * @description Bulk upsert employee shifts by employee_id and date.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<BatchUpsertShiftsBody, BatchUpsertShiftsParameters, TMeta, TSignal>,
      client?: (
        schema: BatchUpsertShiftsSchema,
        options: ServiceOperationMutationFnOptions<BatchUpsertShiftsBody, BatchUpsertShiftsParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<BatchUpsertShiftsData, BatchUpsertShiftsError>>
    ): Promise<RequestFnResponse<BatchUpsertShiftsData, BatchUpsertShiftsError>>;
    /**
     * @summary Batch Upsert Shifts
     * @description Bulk upsert employee shifts by employee_id and date.
     */
    getMutationKey(
      parameters: DeepReadonly<BatchUpsertShiftsParameters> | void
    ): ServiceOperationMutationKey<BatchUpsertShiftsSchema, BatchUpsertShiftsParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Batch Upsert Shifts
     * @description Bulk upsert employee shifts by employee_id and date.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeeShiftsService.batchUpsertShifts.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeeShiftsService.batchUpsertShifts.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends BatchUpsertShiftsBody, TContext = unknown>(
      parameters: DeepReadonly<BatchUpsertShiftsParameters>,
      options?: ServiceOperationUseMutationOptions<
        BatchUpsertShiftsSchema,
        BatchUpsertShiftsData,
        BatchUpsertShiftsParameters,
        TVariables,
        OperationError<BatchUpsertShiftsError>,
        TContext
      >
    ): UseMutationResult<BatchUpsertShiftsData, OperationError<BatchUpsertShiftsError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Batch Upsert Shifts
     * @description Bulk upsert employee shifts by employee_id and date.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeeShiftsService.batchUpsertShifts.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeeShiftsService.batchUpsertShifts.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<BatchUpsertShiftsBody, BatchUpsertShiftsParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        BatchUpsertShiftsSchema,
        BatchUpsertShiftsData,
        BatchUpsertShiftsParameters,
        TVariables,
        OperationError<BatchUpsertShiftsError>,
        TContext
      >
    ): UseMutationResult<BatchUpsertShiftsData, OperationError<BatchUpsertShiftsError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Batch Upsert Shifts
     * @description Bulk upsert employee shifts by employee_id and date.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const batchUpsertShiftsTotal = qraft.employeeShiftsService.batchUpsertShifts.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const batchUpsertShiftsTotal = qraft.employeeShiftsService.batchUpsertShifts.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            BatchUpsertShiftsBody,
            BatchUpsertShiftsData,
            BatchUpsertShiftsParameters,
            OperationError<BatchUpsertShiftsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpsertShiftsSchema,
            BatchUpsertShiftsBody,
            BatchUpsertShiftsData,
            BatchUpsertShiftsParameters,
            OperationError<BatchUpsertShiftsError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Batch Upsert Shifts
     * @description Bulk upsert employee shifts by employee_id and date.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const batchUpsertShiftsPendingMutationVariables = qraft.employeeShiftsService.batchUpsertShifts.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const batchUpsertShiftsMutationData = qraft.employeeShiftsService.batchUpsertShifts.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        BatchUpsertShiftsData,
        OperationError<BatchUpsertShiftsError>,
        MutationVariables<BatchUpsertShiftsBody, BatchUpsertShiftsParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            BatchUpsertShiftsBody,
            BatchUpsertShiftsData,
            BatchUpsertShiftsParameters,
            OperationError<BatchUpsertShiftsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpsertShiftsSchema,
            BatchUpsertShiftsBody,
            BatchUpsertShiftsData,
            BatchUpsertShiftsParameters,
            OperationError<BatchUpsertShiftsError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          BatchUpsertShiftsData,
          OperationError<BatchUpsertShiftsError>,
          MutationVariables<BatchUpsertShiftsBody, BatchUpsertShiftsParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Batch Upsert Shifts
     * @description Bulk upsert employee shifts by employee_id and date.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            BatchUpsertShiftsBody,
            BatchUpsertShiftsData,
            BatchUpsertShiftsParameters,
            OperationError<BatchUpsertShiftsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpsertShiftsSchema,
            BatchUpsertShiftsBody,
            BatchUpsertShiftsData,
            BatchUpsertShiftsParameters,
            OperationError<BatchUpsertShiftsError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Batch Upsert Shifts
     * @description Bulk upsert employee shifts by employee_id and date.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeeShiftsService.batchUpsertShifts.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeeShiftsService.batchUpsertShifts.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              BatchUpsertShiftsBody,
              BatchUpsertShiftsData,
              BatchUpsertShiftsParameters,
              OperationError<BatchUpsertShiftsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BatchUpsertShiftsSchema,
              BatchUpsertShiftsBody,
              BatchUpsertShiftsData,
              BatchUpsertShiftsParameters,
              OperationError<BatchUpsertShiftsError>,
              TContext
            >
      ):
        | Mutation<
            BatchUpsertShiftsData,
            BatchUpsertShiftsError,
            MutationVariables<BatchUpsertShiftsBody, BatchUpsertShiftsParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              BatchUpsertShiftsBody,
              BatchUpsertShiftsData,
              BatchUpsertShiftsParameters,
              OperationError<BatchUpsertShiftsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BatchUpsertShiftsSchema,
              BatchUpsertShiftsBody,
              BatchUpsertShiftsData,
              BatchUpsertShiftsParameters,
              OperationError<BatchUpsertShiftsError>,
              TContext
            >
      ): Array<
        Mutation<
          BatchUpsertShiftsData,
          BatchUpsertShiftsError,
          MutationVariables<BatchUpsertShiftsBody, BatchUpsertShiftsParameters>,
          TContext
        >
      >;
    };
    schema: BatchUpsertShiftsSchema;
    types: {
      parameters: BatchUpsertShiftsParameters;
      data: BatchUpsertShiftsData;
      error: BatchUpsertShiftsError;
      body: BatchUpsertShiftsBody;
    };
  };
  /**
   * @summary Batch Delete Shifts
   * @description Bulk delete employee shifts by employee_id and date. Returns count of deleted rows.
   */
  batchDeleteShifts: {
    /**
     * @summary Batch Delete Shifts
     * @description Bulk delete employee shifts by employee_id and date. Returns count of deleted rows.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<BatchDeleteShiftsBody, BatchDeleteShiftsParameters, TMeta, TSignal>,
      client?: (
        schema: BatchDeleteShiftsSchema,
        options: ServiceOperationMutationFnOptions<BatchDeleteShiftsBody, BatchDeleteShiftsParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<BatchDeleteShiftsData, BatchDeleteShiftsError>>
    ): Promise<RequestFnResponse<BatchDeleteShiftsData, BatchDeleteShiftsError>>;
    /**
     * @summary Batch Delete Shifts
     * @description Bulk delete employee shifts by employee_id and date. Returns count of deleted rows.
     */
    getMutationKey(
      parameters: DeepReadonly<BatchDeleteShiftsParameters> | void
    ): ServiceOperationMutationKey<BatchDeleteShiftsSchema, BatchDeleteShiftsParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Batch Delete Shifts
     * @description Bulk delete employee shifts by employee_id and date. Returns count of deleted rows.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeeShiftsService.batchDeleteShifts.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeeShiftsService.batchDeleteShifts.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends BatchDeleteShiftsBody, TContext = unknown>(
      parameters: DeepReadonly<BatchDeleteShiftsParameters>,
      options?: ServiceOperationUseMutationOptions<
        BatchDeleteShiftsSchema,
        BatchDeleteShiftsData,
        BatchDeleteShiftsParameters,
        TVariables,
        OperationError<BatchDeleteShiftsError>,
        TContext
      >
    ): UseMutationResult<BatchDeleteShiftsData, OperationError<BatchDeleteShiftsError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Batch Delete Shifts
     * @description Bulk delete employee shifts by employee_id and date. Returns count of deleted rows.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeeShiftsService.batchDeleteShifts.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeeShiftsService.batchDeleteShifts.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<BatchDeleteShiftsBody, BatchDeleteShiftsParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        BatchDeleteShiftsSchema,
        BatchDeleteShiftsData,
        BatchDeleteShiftsParameters,
        TVariables,
        OperationError<BatchDeleteShiftsError>,
        TContext
      >
    ): UseMutationResult<BatchDeleteShiftsData, OperationError<BatchDeleteShiftsError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Batch Delete Shifts
     * @description Bulk delete employee shifts by employee_id and date. Returns count of deleted rows.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const batchDeleteShiftsTotal = qraft.employeeShiftsService.batchDeleteShifts.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const batchDeleteShiftsTotal = qraft.employeeShiftsService.batchDeleteShifts.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            BatchDeleteShiftsBody,
            BatchDeleteShiftsData,
            BatchDeleteShiftsParameters,
            OperationError<BatchDeleteShiftsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchDeleteShiftsSchema,
            BatchDeleteShiftsBody,
            BatchDeleteShiftsData,
            BatchDeleteShiftsParameters,
            OperationError<BatchDeleteShiftsError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Batch Delete Shifts
     * @description Bulk delete employee shifts by employee_id and date. Returns count of deleted rows.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const batchDeleteShiftsPendingMutationVariables = qraft.employeeShiftsService.batchDeleteShifts.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const batchDeleteShiftsMutationData = qraft.employeeShiftsService.batchDeleteShifts.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        BatchDeleteShiftsData,
        OperationError<BatchDeleteShiftsError>,
        MutationVariables<BatchDeleteShiftsBody, BatchDeleteShiftsParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            BatchDeleteShiftsBody,
            BatchDeleteShiftsData,
            BatchDeleteShiftsParameters,
            OperationError<BatchDeleteShiftsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchDeleteShiftsSchema,
            BatchDeleteShiftsBody,
            BatchDeleteShiftsData,
            BatchDeleteShiftsParameters,
            OperationError<BatchDeleteShiftsError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          BatchDeleteShiftsData,
          OperationError<BatchDeleteShiftsError>,
          MutationVariables<BatchDeleteShiftsBody, BatchDeleteShiftsParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Batch Delete Shifts
     * @description Bulk delete employee shifts by employee_id and date. Returns count of deleted rows.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            BatchDeleteShiftsBody,
            BatchDeleteShiftsData,
            BatchDeleteShiftsParameters,
            OperationError<BatchDeleteShiftsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchDeleteShiftsSchema,
            BatchDeleteShiftsBody,
            BatchDeleteShiftsData,
            BatchDeleteShiftsParameters,
            OperationError<BatchDeleteShiftsError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Batch Delete Shifts
     * @description Bulk delete employee shifts by employee_id and date. Returns count of deleted rows.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeeShiftsService.batchDeleteShifts.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeeShiftsService.batchDeleteShifts.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              BatchDeleteShiftsBody,
              BatchDeleteShiftsData,
              BatchDeleteShiftsParameters,
              OperationError<BatchDeleteShiftsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BatchDeleteShiftsSchema,
              BatchDeleteShiftsBody,
              BatchDeleteShiftsData,
              BatchDeleteShiftsParameters,
              OperationError<BatchDeleteShiftsError>,
              TContext
            >
      ):
        | Mutation<
            BatchDeleteShiftsData,
            BatchDeleteShiftsError,
            MutationVariables<BatchDeleteShiftsBody, BatchDeleteShiftsParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              BatchDeleteShiftsBody,
              BatchDeleteShiftsData,
              BatchDeleteShiftsParameters,
              OperationError<BatchDeleteShiftsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BatchDeleteShiftsSchema,
              BatchDeleteShiftsBody,
              BatchDeleteShiftsData,
              BatchDeleteShiftsParameters,
              OperationError<BatchDeleteShiftsError>,
              TContext
            >
      ): Array<
        Mutation<
          BatchDeleteShiftsData,
          BatchDeleteShiftsError,
          MutationVariables<BatchDeleteShiftsBody, BatchDeleteShiftsParameters>,
          TContext
        >
      >;
    };
    schema: BatchDeleteShiftsSchema;
    types: {
      parameters: BatchDeleteShiftsParameters;
      data: BatchDeleteShiftsData;
      error: BatchDeleteShiftsError;
      body: BatchDeleteShiftsBody;
    };
  };
}
/**
 * @summary Get Shifts
 * @description Get employee shifts with optional filters.
 */
export const getShiftsEmployeesShiftsGet = {
  schema: {
    method: 'get',
    url: '/employees/shifts/',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetShiftsEmployeesShiftsGetSchema;
  [QraftServiceOperationsToken]: EmployeeShiftsService['getShiftsEmployeesShiftsGet'];
};
/**
 * @summary Batch Upsert Shifts
 * @description Bulk upsert employee shifts by employee_id and date.
 */
export const batchUpsertShifts = {
  schema: {
    method: 'post',
    url: '/employees/shifts/batch/upsert',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: BatchUpsertShiftsSchema;
  [QraftServiceOperationsToken]: EmployeeShiftsService['batchUpsertShifts'];
};
/**
 * @summary Batch Delete Shifts
 * @description Bulk delete employee shifts by employee_id and date. Returns count of deleted rows.
 */
export const batchDeleteShifts = {
  schema: {
    method: 'post',
    url: '/employees/shifts/batch/delete',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: BatchDeleteShiftsSchema;
  [QraftServiceOperationsToken]: EmployeeShiftsService['batchDeleteShifts'];
};
export const employeeShiftsService = {
  getShiftsEmployeesShiftsGet,
  batchUpsertShifts,
  batchDeleteShifts,
} as const;
type GetShiftsEmployeesShiftsGetSchema = {
  method: 'get';
  url: '/employees/shifts/';
  security: ['HTTPBearer'];
};
type GetShiftsEmployeesShiftsGetParameters = paths['/employees/shifts/']['get']['parameters'];
type GetShiftsEmployeesShiftsGetData =
  paths['/employees/shifts/']['get']['responses']['200']['content']['application/json'];
type GetShiftsEmployeesShiftsGetError =
  paths['/employees/shifts/']['get']['responses']['422']['content']['application/json'];
type BatchUpsertShiftsSchema = {
  method: 'post';
  url: '/employees/shifts/batch/upsert';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type BatchUpsertShiftsParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type BatchUpsertShiftsData =
  paths['/employees/shifts/batch/upsert']['post']['responses']['200']['content']['application/json'];
type BatchUpsertShiftsError =
  paths['/employees/shifts/batch/upsert']['post']['responses']['422']['content']['application/json'];
type BatchUpsertShiftsBody =
  paths['/employees/shifts/batch/upsert']['post']['requestBody']['content']['application/json'];
type BatchDeleteShiftsSchema = {
  method: 'post';
  url: '/employees/shifts/batch/delete';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type BatchDeleteShiftsParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type BatchDeleteShiftsData =
  paths['/employees/shifts/batch/delete']['post']['responses']['200']['content']['application/json'];
type BatchDeleteShiftsError =
  paths['/employees/shifts/batch/delete']['post']['responses']['422']['content']['application/json'];
type BatchDeleteShiftsBody =
  paths['/employees/shifts/batch/delete']['post']['requestBody']['content']['application/json'];
